module.exports = __webpack_public_path__ + "static/media/password2.83c20f6b.png";